export default __webpack_public_path__ + "static/media/Poorvika-rectangle.778c4f41.png";